import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const API_BASE_URL = "https://api.saadmotors.com/view_purchase.php";

const ViewPurchase = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [userId, setUserId] = useState("");
  const [userFullName, setUserFullName] = useState("");
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedUserType = localStorage.getItem("usertype");
    const storedUserId = localStorage.getItem("userId");
    const storedFName = localStorage.getItem("fname");
    const storedLName = localStorage.getItem("lname");

    if (!storedUserType) {
      navigate("/login");
    } else {
      setUserType(storedUserType);
      setUserId(storedUserId);
      if (storedFName && storedLName) {
        setUserFullName(`${storedFName} ${storedLName}`);
      }
    }

    if (storedUserId) {
      fetchPurchases(storedUserId);
    } else {
      setError("User ID not found in localStorage");
      setLoading(false);
    }
  }, [navigate]);

  const fetchPurchases = async (userId) => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`${API_BASE_URL}?action=get_purchases&user_id=${userId}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch purchases');
      }

      // console.log("Fetched purchases:", data.data);
      setPurchases(data.data || []);
    } catch (error) {
      console.error("Error fetching purchases:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="admin-container">
      <div className="sidebar-container">
        {userType === "administrator" && <AdministratorSidebar />}
        {userType === "admin" && <AdminSidebar />}
        {userType === "user" && <UserSidebar />}
      </div>

      <div className="admin-content">
        <div className="adminnavbar">
          <h1>Welcome to the Admin Panel, {userFullName}</h1>
          <button onClick={logout} className="logoutbtn">
            Logout
          </button>
        </div>

        <div className="mainsection">
          <h3>Your Purchase History</h3>
          
          {error && (
            <div className="alert alert-danger">
              {error}
              <button 
                className="btn btn-sm btn-primary ms-2"
                onClick={() => fetchPurchases(userId)}
              >
                Retry
              </button>
            </div>
          )}

          {loading ? (
            <div className="text-center my-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading your purchases...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Stock ID</th>
                    <th>Maker</th>
                    <th>Model</th>
                    <th>Chassis</th>
                    <th>Price</th>
                    <th>Purchase Date</th>
                  </tr>
                </thead>
                <tbody>
                  {purchases.length > 0 ? (
                    purchases.map((purchase) => (
                      <tr key={purchase.id}>
                        <td>{purchase.stock_id}</td>
                        <td>{purchase.maker}</td>
                        <td>{purchase.model}</td>
                        <td>{purchase.vin}</td>
                        <td>${purchase.price}</td>
                        <td>{new Date(purchase.sale_date).toLocaleDateString()}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        {error ? 'Error loading purchases' : 'No purchases found'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewPurchase;